import React, { useEffect, useState } from "react";
import { Layout } from "components/Layout";
import { Preloader } from "components/Preloader";
import { SubtitlesBlock } from "./components/SubtitlesBlock";
import { Head2 } from "./components/Head2";
import { useAudioStateContext } from "hooks/useAudioStateContext";
import { useAudioHandlesContext } from "hooks/useAudioHandlesContext";
import { VideoPlayer } from "./components/VideoPlayer";
import { WaitingBadge } from "./components/WaitingBadge";
import { AudioFooter } from "./components/Footer/Footer";
import { SubtitleRecommendation } from "./components/SubtitleRecommendation";
import { useResize } from "./useResize";
import { DebugFooter } from "./components/DebugFooter";
import { SubtitleLoadStatus } from "./components/SubtitleLoadStatus";
import { useHandleSavedTrackPlay } from "../../../hooks/useHandleSavedTrackPlay";
import { useLastActiveShortcuts } from "../../../hooks/useLastActiveShortcuts";
import { UiProvider } from "../../../providers/AudioProvider/uiStateProvider";
import { CorrectionProvider } from "../../../providers/CorrectionProvider";
import { RepublishSectionProvider } from "../../../providers/RepublishSectionProvider";

import { useLocation } from "react-router-dom";
import { autoStreamLang, searchWithLang } from "./streamLang";

export function Audios() {
    const handles = useAudioHandlesContext();
    const state = useAudioStateContext();
    const location = useLocation();
    useHandleSavedTrackPlay({ handles, state });
    useLastActiveShortcuts({ handles, state });
    window.state = state; // TODO remove on prod
    const [bodyHeight, setBodyHeight] = useState(300);
    const { handleMouseDown } = useResize({ setBodyHeight });

    useEffect(() => {
        handles.setRussian(true);
        handles.setSubtitleMode(true);
        handles.setShowOriginalLanguage(true);

        const searchParams = new URLSearchParams(location.search);
        const lang = searchParams.get("lang") === "zh" ? "ch" : searchParams.get("lang");
        if (lang) {
            handles.setLang(lang as any);
            handles.setToLang(lang);
            handles.setUrlLang(lang);
            console.log("Setting urlLang:", lang);
        }
    }, [location.search]);

    // Эфир с одним языком перевода, адрес без `&lang=` (проба P50m10c: только русский столбец, ♪ нет) — язык
    // перевода редактор берёт сам: адрес дописывается и страница открывается заново, как при смене языка в шапке
    // (`handleLangSwitch`) — дальше всё как при заходе по полной ссылке.
    const autoLang = autoStreamLang(
        location.pathname,
        location.search,
        state.realtimeEditorStatus,
        state.originalLang,
    );
    useEffect(() => {
        if (autoLang) {
            window.location.replace(`${location.pathname}${searchWithLang(location.search, autoLang)}`);
        }
    }, [autoLang, location.pathname, location.search]);

    // ?st=<ms> ведёт провайдер: Layout → setTime → setScrollTo(st / zoom). Здесь был второй путь — поиск
    // колонки по `[class*="subtitles_block"]`; у ленты класс styled-components, он не находил ничего и
    // только 10 с крутил таймер. ?cue=<реплика> (из плеера эфира) — SubtitlesBlock/useLinkTarget.

    return (
        <UiProvider>
            <CorrectionProvider>
                <RepublishSectionProvider>
                <Layout context={{ state, handles }}>
                    {Boolean(state["mp3"]) && <VideoPlayer context={{ state, handles }} />}
                    {/* Почему всё остановилось — и как продолжить, если реплика не приедет. */}
                    <WaitingBadge />
                    <Head2
                        context={{ state, handles }}
                        languageShown={false}
                        originalLanguageShown={false}
                    />

                    {!state["mp3"] && <Preloader />}
                    <SubtitleLoadStatus request={state.subtitlesRequest} onRetry={() => void handles.refreshAllSubtitles()} />

                    {Boolean(state["mp3"]) && state.subtitlesRequest.hasData && (
                        <SubtitlesBlock
                            height={state.editedRecommendationSubtitle ? bodyHeight : undefined}
                        />
                    )}
                    {state.editedRecommendationSubtitle ? (
                        <SubtitleRecommendation onMouseDown={handleMouseDown} />
                    ) : (
                        <AudioFooter
                            state={state}
                            handles={handles}
                            view={["audioVolume", "zoomLevel", "voicingSpacesMinimum", "speed"]}
                        />
                    )}
                    {/*<DebugFooter />*/}
                </Layout>
                </RepublishSectionProvider>
            </CorrectionProvider>
        </UiProvider>
    );
}
